// extracted by mini-css-extract-plugin
export default {"tableContainer":"WorkersTable_tableContainer__9zwYr","table":"WorkersTable_table__TqBjj"};